export default {
  name: 'fa',
  el: {
    colorpicker: {
      confirm: 'تایید',
      clear: 'حذف',
    },
    datepicker: {
      now: 'اکنون',
      today: 'امروز',
      cancel: 'انصراف',
      clear: 'حذف',
      confirm: 'تایید',
      selectDate: 'انتخاب تاریخ',
      selectTime: 'انتخاب زمان',
      startDate: 'تاریخ شروع',
      startTime: 'زمان شروع',
      endDate: 'تاریخ پایان',
      endTime: 'زمان پایان',
      prevYear: 'سال قبل',
      nextYear: 'سال بعد',
      prevMonth: 'ماه قبل',
      nextMonth: 'ماه بعد',
      year: 'سال',
      month1: 'ژانویه',
      month2: 'فوریه',
      month3: 'مارس',
      month4: 'آوریل',
      month5: 'مه',
      month6: 'ژوئن',
      month7: 'جولای',
      month8: 'اوت',
      month9: 'سپتامبر',
      month10: 'اکتبر',
      month11: 'نوامبر',
      month12: 'دسامبر',
      // week: 'week',
      weeks: {
        sun: 'یکشنبه',
        mon: 'دوشنبه',
        tue: 'سه​شنبه',
        wed: 'چهارشنبه',
        thu: 'پنج​شنبه',
        fri: 'جمعه',
        sat: 'شنبه',
      },
      months: {
        jan: 'ژانویه',
        feb: 'فوریه',
        mar: 'مارس',
        apr: 'آوریل',
        may: 'مه',
        jun: 'ژوئن',
        jul: 'جولای',
        aug: 'اوت',
        sep: 'سپتامبر',
        oct: 'اکتبر',
        nov: 'نوامبر',
        dec: 'دسامبر',
      },
    },
    select: {
      loading: 'در حال بارگذاری',
      noMatch: 'هیچ نتیجه‌ای پیدا نشد',
      noData: 'اطلاعاتی وجود ندارد',
      placeholder: 'انتخاب کنید',
    },
    cascader: {
      noMatch: 'هیچ نتیجه‌ای پیدا نشد',
      loading: 'در حال بارگذاری',
      placeholder: 'انتخاب کنید',
      noData: 'اطلاعاتی وجود ندارد',
    },
    pagination: {
      goto: 'برو به',
      pagesize: '/صفحه',
      total: 'مجموع {total}',
      pageClassifier: '',
      page: 'صفحه',
      prev: 'صفحه قبل',
      next: 'صفحه بعد',
      currentPage: 'صفحه {pager}',
      prevPages: '{pager} صفحه قبل',
      nextPages: '{pager} صفحه بعد',
    },
    messagebox: {
      title: 'پیام',
      confirm: 'تایید',
      cancel: 'انصراف',
      error: 'ورودی غیر مجاز',
    },
    upload: {
      deleteTip: 'برای پاک کردن حذف را فشار دهید',
      delete: 'حذف',
      preview: 'پیش‌نمایش',
      continue: 'ادامه',
    },
    table: {
      emptyText: 'اطلاعاتی وجود ندارد',
      confirmFilter: 'تایید',
      resetFilter: 'حذف',
      clearFilter: 'همه',
      sumText: 'جمع',
    },
    tree: {
      emptyText: 'اطلاعاتی وجود ندارد',
    },
    transfer: {
      noMatch: 'هیچ نتیجه‌ای پیدا نشد',
      noData: 'اطلاعاتی وجود ندارد',
      titles: ['لیست 1', 'لیست 2'],
      filterPlaceholder: 'کلید واژه‌ها را وارد کن',
      noCheckedFormat: '{total} مورد',
      hasCheckedFormat: '{checked} مورد از {total} مورد انتخاب شده است',
    },
    image: {
      error: 'خطا در بارگذاری تصویر',
    },
    pageHeader: {
      title: 'بازگشت',
    },
    popconfirm: {
      confirmButtonText: 'بله',
      cancelButtonText: 'خیر',
    },
  },
}
